import { create } from 'zustand';

type StoreyVisibilityState = {
    hiddenStoreyGlobalIds: ReadonlySet<string>;
    setHiddenStoreyGlobalIds: (ids: ReadonlySet<string>) => void;
};

export const useStoreyVisibilityStore = create<StoreyVisibilityState>((set) => ({
    hiddenStoreyGlobalIds: new Set(),
    setHiddenStoreyGlobalIds: (ids) => set({ hiddenStoreyGlobalIds: ids }),
}));
